// extracted by mini-css-extract-plugin
export default {"lista":"politicasPrivacidad_lista__D3Zy4","item":"politicasPrivacidad_item__eTqRh","text":"politicasPrivacidad_text__cDKgv"};